import { normalizeTestName } from "./patientCognitiveRadar";

const HINTING_ALIASES = ["hinting_test", "hinting"];
const EYES_ALIASES = [
  "reading_the_mind_in_the_eyes",
  "reading_the_mind_in_the_eyes_test",
];

const matchesTest = (testName, aliases) => {
  const normalized = normalizeTestName(testName);
  return aliases.some(
    (alias) => normalized === alias || normalized.includes(alias)
  );
};

const getTestScore = (test) => {
  const score = test?.testResultNumber;
  if (score == null || Number.isNaN(Number(score))) return null;
  return Number(score);
};

const toDayKey = (testDay) => {
  const date = new Date(testDay);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString().slice(0, 10);
};

const pickLatestTest = (tests) => {
  if (!tests.length) return null;

  return tests.reduce((latest, test) => {
    if (!latest) return test;
    return new Date(test.testDay) > new Date(latest.testDay) ? test : latest;
  }, null);
};

export const buildSocialCognitionScatter = (tests = []) => {
  const hintingTests = tests.filter((test) =>
    matchesTest(test.testName, HINTING_ALIASES)
  );
  const eyesTests = tests.filter((test) =>
    matchesTest(test.testName, EYES_ALIASES)
  );

  const hintingByDay = new Map();
  const eyesByDay = new Map();

  for (const test of hintingTests) {
    const day = toDayKey(test.testDay);
    const score = getTestScore(test);
    if (!day || score == null) continue;
    hintingByDay.set(day, score);
  }

  for (const test of eyesTests) {
    const day = toDayKey(test.testDay);
    const score = getTestScore(test);
    if (!day || score == null) continue;
    eyesByDay.set(day, score);
  }

  const sharedDays = [...hintingByDay.keys()].filter((day) =>
    eyesByDay.has(day)
  );

  let points = sharedDays
    .sort()
    .map((day) => ({
      x: eyesByDay.get(day),
      y: hintingByDay.get(day),
      testDay: day,
      pairedSameDay: true,
    }));

  let usedFallback = false;

  if (points.length === 0) {
    const latestEyes = pickLatestTest(eyesTests);
    const latestHinting = pickLatestTest(hintingTests);
    const x = getTestScore(latestEyes);
    const y = getTestScore(latestHinting);

    if (x != null && y != null) {
      points = [
        {
          x,
          y,
          testDay: toDayKey(latestHinting.testDay || latestEyes.testDay),
          pairedSameDay: false,
        },
      ];
      usedFallback = true;
    }
  }

  return {
    points,
    hasData: points.length > 0,
    usedFallback,
    eyesSessions: eyesTests.length,
    hintingSessions: hintingTests.length,
  };
};
